import axios from "axios";
import { serverUrl } from "../../components/Helpers/Config";
import { tokenAuthorize } from "../../components/Helpers/Common";

export const GET_COMMUNITY_GROUPS = "GET_COMMUNITY_GROUPS";
export const GET_GROUP_LOADING = "GET_GROUP_LOADING";
export const GET_LOADING_OFFSET = "GET_LOADING_OFFSET";

export const getCommunityGroups = (is_Tutor,is_Student) => {
  return (dispatch) => {
    dispatch({
      type: GET_GROUP_LOADING,
      payload: true,
    });
    return axios
      .get(`${serverUrl.CommunityGroupsv3}?is_tutor=${is_Tutor}&is_student=${is_Student}`)
      .then((response) => {
        if (response.status === 200) {
          dispatch({
            type: GET_COMMUNITY_GROUPS,
            payload: response.data,
          });
          dispatch({
            type: GET_GROUP_LOADING,
            payload: false,
          });
        } else {
          dispatch({
            type: GET_GROUP_LOADING,
            payload: false,
          });
        }
      })
      .catch((error) => {
        tokenAuthorize(error?.response?.status);
        console.log(error);
        dispatch({
          type: GET_GROUP_LOADING,
          payload: false,
        });
      });
  };
};

// export const fetchCommunityGroupsRequest = () => {
//   return {
//     type: FETCH_COMMUNITY_GROUPS_REQUEST,
//   };
// };

// export const fetchCommunityGroupsSuccess = (groups) => {
//   return {
//     type: FETCH_COMMUNITY_GROUPS_SUCCESS,
//     payload: groups.results,
//   };
// };

// export const fetchCommunityGroupsFailure = (error) => {
//   return {
//     type: FETCH_COMMUNITY_GROUPS_FAILURE,
//     payload: error,
//   };
// };

// export const getAllCommunityGroups = () => {
//   return (dispatch) => {
//     dispatch(fetchCommunityGroupsRequest());
//     axios.get(serverUrl.ReflectionGroups)
//       .then((response) => {
//         const groups = response.data;
//         dispatch(fetchCommunityGroupsSuccess(groups));
//       })
//       .catch((error) => {
//         const errorMsg = error.message;
//         dispatch(fetchCommunityGroupsFailure(errorMsg));
//       });
//   };
// };



